/* eslint-disable */

import moment from 'moment'
import * as types from './mutation-types.js'
import * as qm from 'src/utils/utils'
import * as api from 'src/api/index'
import * as formatter from 'src/utils/formatter'
/* eslint-enable */
export const setAccountInfo = async function({commit, dispatch, state}, from) {
  try {
    if (state.accountInfo.uid) {
      return
    }
    // 登录
    const res = await api.getAccountInfo()
    if (res.user) {
      commit(
        types.SET_ACCOUNT_INFO,
        Object.assign({}, state.accountInfo, res.user, {isLogin: true}),
      )
      qm.setGAUserId(res.user.uid)
    }
    // 查 openId
    const res2 = await api.checkHasOpenId(res.user.uid)
    if (res2.ok && res2.hasOpenId) {
      commit(
        types.SET_ACCOUNT_INFO,
        Object.assign({}, state.accountInfo, {isBoundWechat: true}),
      )
    }
    // 查管理员权限

    const res3 = await api.checkAccountAccess()
    if (res3.ok) {
      commit(types.SET_ADMIN_ACCESS, true)
    } else {
      commit(types.SET_ADMIN_ACCESS, false)
    }
  } catch (e) {
    qm.log('setAccountInfo error:', e)
    commit(types.SET_ADMIN_ACCESS, false)
  }
}

export const setMagazineInfo = async function({commit, state}, force) {
  if (!force && state.magazineInfo.id) {
    return
  }
  const magazineId = state.route.params.magazineId
  const res = await api.getMagazineInfo(magazineId)
  if (res.ok) {
    const magazineInfo = formatter.magazineInfoEventFormatter(
      res.events[0],
    )
    commit(types.SET_MAGAZINE_INFO, magazineInfo)
  }
}

export const setMagazineConfig = async function({commit, state}, force) {
  if (!force && state.magazineConfig.basicConfig) {
    return
  }
  const magazineId = state.route.params.magazineId
  const res = await api.getMagazineConfig(magazineId)
  if (res.ok) {
    const magazineConfig = formatter.magazineConfigEventFormatter(
      res.events[0],
    )
    commit(types.SET_MAGAZINE_CONFIG, magazineConfig)
  }
}

/**
 * Action 设置 publicationInfo
 * @param {Function} commit [Vuex.commit]
 * @param state [Vuex.state]
 * @param {Boolean} [needUpdate]
 * @returns {Promise<void>}
 */
export const actionSetPublicationInfo = async function(
  {commit, state},
  needUpdate,
) {
  let refresh
  if (needUpdate === 'refresh') {
    refresh = 1
  }
  const {publicationId} = state.route.params
  const conditions = [
    () => qm.isEmptyObject(state.publicationInfo),
    () => needUpdate,
    () => state.publicationInfo.id !== Number(publicationId),
  ]
  if (conditions.some(fn => fn())) {
    const res = await api.getPublication(publicationId, refresh)
    if (res.ok) {
      const publicationInfo = formatter.publicationFormatter(
        res.publication,
      )
      const scopesRes = await api.getPublicationScopes(publicationId)
      publicationInfo.scope = formatter.publicationScopeFormatter(
        scopesRes,
      )
      // 创建时间
      publicationInfo.createdTime = res.publication.createdTime
      if (publicationInfo.appId) {
        const [appInfoRes, appListRes] = await Promise.all([
          api.getAppInfo(publicationInfo.appId),
          api.getExtAppList(publicationInfo.appId),
        ])
        if (appInfoRes.ok) {
          publicationInfo.appInfo = appInfoRes.app
        }
        if (appListRes.ok) {
          publicationInfo.navigateToMiniProgramList = appListRes.apps.map(
            app => ({
              appId: app.appId,
              name: app.appName || '未命名小程序',
            }),
          )
        }
      }
      commit(types.SET_PUBLICATION_INFO, publicationInfo)
    } else {
      // 没有 this
      qm.log(res.error.desc)
    }
  }
}

/**
 * Action 设置 magazineInfo
 * 自动做了前置 publicationInfo 的获取
 * @param [dispatch]
 * @param [commit]
 * @param [state]
 * @param needUpdate {Boolean}
 * @returns {Promise<void>}
 */
export async function actionSetMagazineInfo(
  {dispatch, commit, state},
  needUpdate,
) {
  const {magazineId} = state.route.params
  const conditions = [
    () => qm.isEmptyObject(state.magazineInfo),
    () => needUpdate,
    () => state.magazineInfo.id !== Number(magazineId),
  ]
  if (conditions.some(fn => fn())) {
    const res = await api.getMagazineInfo(magazineId)
    if (res.ok) {
      const magazineInfo = formatter.magazineInfoEventFormatter(
        res.events[0],
      )
      commit(types.SET_MAGAZINE_INFO, magazineInfo)
    } else {
      throw new Error(res.errorMessage || res.error.desc)
    }
  }
}

/**
 * Action 设置 magazineConfig
 * 自动做了前置 magazineInfo 的获取
 * @param [dispatch]
 * @param [commit]
 * @param [state]
 * @param [needUpdate] {Boolean}
 * @returns {Promise<void>}
 */
export async function actionSetMagazineConfig(
  {dispatch, commit, state},
  needUpdate,
) {
  const {magazineId} = state.route.params
  const conditions = [
    () => qm.isEmptyObject(state.magazineConfig),
    () => needUpdate,
    () => state.magazineConfig.id !== Number(magazineId),
  ]
  if (conditions.some(fn => fn())) {
    await dispatch('actionSetMagazineInfo')
    const res = await api.getMagazineConfig(magazineId)
    if (res.ok) {
      const magazineConfig = formatter.magazineConfigEventFormatter(
        res.events[0],
      )
      commit(types.SET_MAGAZINE_CONFIG, magazineConfig)
    } else {
      throw new Error(res.errorMessage || res.error.desc)
    }
  }
}

/**
 * Action 获取/更新 vuex 中的 magazine list
 * @param commit
 * @param state
 * @param needUpdate
 * @returns {Promise<void>}
 */
export async function actionGetMagazineList({commit, state}, needUpdate) {
  const {publicationId} = state.route.params
  // 判断一下条件，是否要更新
  const conditions = [
    // publication 切换了
    () => Number(publicationId) !== state.publicationInfo.id,
    // 需要强制更新
    () => needUpdate,
    // 没有 magazineList 或者 magazineList 为空
    () => !state.magazineList || state.magazineList.length === 0,
  ]
  if (conditions.some(fn => fn())) {
    const res = await api.columnList(true)
    if (res.ok) {
      const magazineList = res.columns.map(
        formatter.magazineEventFormatter,
      )
      commit(types.SET_MAGAZINE_LIST, magazineList)
    } else {
      throw new Error(res.errorMessage || res.error.desc)
    }
  }
}

/**
 * Action 获取/更新 vuex 中的 magazine kind list
 * @param commit
 * @param state
 * @param needUpdate
 * @returns {Promise<void>}
 */
export async function actionGetColumnKindList({commit, state}, needUpdate) {
  const {publicationId} = state.route.params
  // 非 BITC 不显示
  if (!qm.isSupportModule('catalog')) {
    return
  }
  if (
    !state.columnKindList ||
    Number(publicationId) !== state.publicationInfo.id ||
    needUpdate
  ) {
    const res = await api.Ajax({
      url: '/v2/catalog.list',
      data: {
        // catalog_type: 1,
      },
    })
    if (!res.ok) {
      throw new Error('分类获取失败')
    }
    const catalogs = res.catalogs.map(e => {
      return {
        ...e,
        value: e.name,
        nv: '',
      }
    })
    // 获取 栏目分类下的栏目
    const promise = []
    for (const catalog of catalogs) {
      promise.push(
        api.Ajax({
          url: '/v2/catalog.list.all',
          data: {
            catalog_id: catalog.id,
          },
        }),
      )
    }
    const resArr = await Promise.all(promise)
    for (let i = 0; i < catalogs.length; i++) {
      catalogs[i].lists = qm.get(resArr[i], 'lists') || []
    }
    const kindList = catalogs
    commit('setColumnKindList', kindList)
  }
}

export async function actionGetLibList({commit, state}, needUpdate) {
  const {publicationId} = state.route.params
  const conditions = [
    // publication 切换了
    () => Number(publicationId) !== state.publicationInfo.id,
    // 需要强制更新
    () => needUpdate,
    // 没有 magazineList 或者 magazineList 为空
    () => !state.libList || state.libList.length === 0,
  ]
  if (conditions.some(fn => fn())) {
    const res = await api.getQuizLibList(publicationId)
    if (res.ok) {
      const libList = res.libs.map(formatter.libInfoFormatter)
      commit(types.SET_LIB_LIST, libList)
    } else {
      throw new Error(res.errorMessage || res.error.desc)
    }
  }
}

/**
 * recordNotIncludedProvider 记录一个未收录的 provider
 * @param commit
 * @param state
 * @param {Number} mid
 * @param {Object} provider
 */
export function recordNotIncludedProvider({commit, state}, {mid, provider}) {
  const providerMap = state.notIncludedProviders
  qm.log('recordNotIncludedProvider\n mid, provider :\n', mid, provider)
  if (providerMap[`${mid}`]) {
    providerMap[`${mid}`].push(provider)
  } else {
    providerMap[`${mid}`] = [provider]
  }
  commit('setNotIncludedProviders', providerMap)
}

/**
 * removeNotIncludedProvider 移除一个已经收录的未收录源
 * @param commit
 * @param state
 * @param mid
 * @param provider
 */
export function removeNotIncludedProvider({commit, state}, {mid, provider}) {
  const providerMap = state.notIncludedProviders
  if (providerMap[`${mid}`] && providerMap[`${mid}`][`${provider.id}`]) {
    providerMap[`${mid}`] = providerMap[`${mid}`].filter(
      item => item.id !== provider.id,
    )
  }
  commit('setNotIncludedProviders', providerMap)
}
